import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { ClientService } from '../../../services/client.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-client-package',
  imports: [SharedModule, DatePickerModule],
  templateUrl: './create-client-package.component.html',
  styleUrl: './create-client-package.component.scss'
})
export class CreateClientPackageComponent implements OnInit{

  @Input() clientId: string = '';
  @Input() type: string = 'Create';
  @Input() allPackages: any[] = [];

  packageForm!: FormGroup;
  submitted = false;
  isLoading = false;

  statusOptions = ['Active', 'Inactive'];
  clients: { label: string; value: string }[] = [];
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  @Input() clientDataToEdit: any = null;

  constructor(private fb: FormBuilder,
    private clientService: ClientService
  ) { }

  ngOnInit() {
    this.packageForm = this.fb.group({
      client_id: [this.clientId || null, Validators.required],
      package_id: [null, Validators.required],
      start_date: [null, Validators.required],
      end_date: [null, Validators.required],
      reminder_before_days: [7, [Validators.required, Validators.min(0)]],
      grace_period: [5, [Validators.required, Validators.min(0)]],
      auto_renewal: [true],
      total_user: [50, [Validators.required, Validators.min(1)]],
      status: ['Active', Validators.required]
    });

    console.log(" all packages", this.allPackages);
    this.allPackages = this.allPackages.map((pkg: any) =>
      ({ name: pkg.package_name, value: pkg.package_id })
    );

    this.getAllClients();

    if (this.type === 'Update' && this.clientDataToEdit) {
      this.packageForm.patchValue({
        client_id: this.clientDataToEdit.client_id,
        package_id: this.clientDataToEdit.package_id,
        start_date: this.clientDataToEdit.start_date,
        end_date: this.clientDataToEdit.end_date,
        reminder_before_days: this.clientDataToEdit.reminder_before_days,
        grace_period: this.clientDataToEdit.grace_period,
        auto_renewal: this.clientDataToEdit.auto_renewal,
        total_user: this.clientDataToEdit.total_user,
        status: this.clientDataToEdit.status
      });

      // start date and end date format
      const startDate = new Date(this.clientDataToEdit.start_date);
      const endDate = new Date(this.clientDataToEdit.end_date);
      this.packageForm.patchValue({
        start_date: startDate,
        end_date: endDate
      });
    }
  }

  getAllClients() {
    const payload = {
      page: 0,
      limit: 500,
      where: {},
      order: { col: '"client"."name"', dir: 'ASC' }
    };
    this.clientService.getAllClients(payload).subscribe({
      next: (res: any) => {
        const rows = res.rows || res.data || [];
        this.clients = rows.map((c: any) => ({
          label: c.name,
          value: c.client_id || c.id
        }));
      },
      error: () => {}
    });
  }

  submitForm() {
    this.submitted = true;
    if (this.packageForm.invalid) return;

    this.isLoading = true;

    const payload: any = {
      client_id: this.packageForm.get('client_id')?.value || this.clientId,
      package_id: this.packageForm.get('package_id')?.value,
      start_date: this.packageForm.get('start_date')?.value,
      end_date: this.packageForm.get('end_date')?.value,
      reminder_before_days: this.packageForm.get('reminder_before_days')?.value,
      grace_period: this.packageForm.get('grace_period')?.value,
      auto_renewal: this.packageForm.get('auto_renewal')?.value,
      total_user: this.packageForm.get('total_user')?.value,
      status: this.packageForm.get('status')?.value
    }


    if (this.type === 'Create') {
      this.clientService.createClientPackage(payload).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.close.emit();
          this.reload.emit();
        },
        error: (err) => {
          this.isLoading = false;
        }
      });
    }
     else {
      payload['id'] = this.clientDataToEdit.id;
      this.clientService.updateClientPackage(payload).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.reload.emit();
          this.close.emit();
        },
        error: (err) => {
          this.isLoading = false;
        }
      });
    }

  }


  handleCloseDialog() {
    this.close.emit();
  }

}
